import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ExchangeandReturnPolicy.css";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
import { useEffect } from "react";
const ExchangeAndReturnPolicy = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const fben ={
    "1": "Exchange and Return Policy",
    "2": "Home"
  }
  
  const fbka ={
    "1": "ವಿನಿಮಯ ಮತ್ತು ವಾಪಸಾತಿ ನೀತಿ",
    "2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ"
  }
  
  const fbte ={
    "1": "మార్పిడి మరియు తిరిగి చెల్లింపు విధానం",
    "2": "హోం"
  }
const fbhi ={
  "1": "विनिमय और वापसी नीति",
  "2": "मुख्य पृष्ठ"
};
const fbta ={
  "1": "முகப்புப் பக்கம்",
  "2": "பரிமாற்றம் மற்றும் திரும்பப் பெறும் கொள்கை"
}
  const sectionshi =[
    { 
      "title": "विनिमय नीति", 
      "content": [
        "हम विशिष्ट परिस्थितियों में उत्पादों के लिए विनिमय प्रदान करते हैं:",
        "विनिमय के लिए पात्रता:",
        "उत्पाद डिलीवरी के समय दोषपूर्ण, क्षतिग्रस्त, या गलत हो।",
        "उत्पाद बिना उपयोग किया हुआ, बिना धोया हुआ हो और अपने मूल स्थिति में हो, जिसमें सभी टैग/लेबल और पैकेजिंग शामिल हो।",
        "विनिमय अनुरोध डिलीवरी के उसी दिन किया जाना चाहिए।"
      ] 
    },
    { 
      "title": "वापसी नीति", 
      "content": [
        "यदि आप अपनी खरीद से पूरी तरह संतुष्ट नहीं हैं, तो निम्नलिखित शर्तों के तहत वापसी स्वीकार की जाती है:",
        "उत्पाद बिना उपयोग किया हुआ, बिना धोया हुआ हो और अपने मूल स्थिति में हो, जिसमें सभी पैकेजिंग और टैग शामिल हो।",
        "वापसी अनुरोध डिलीवरी के 2 दिनों के भीतर किया जाना चाहिए।",
        "\"अवापसी योग्य\" या \"अंतिम बिक्री\" के रूप में चिह्नित आइटम वापसी के लिए पात्र नहीं हैं।"
      ] 
    },
    { 
      "title": "धनवापसी", 
      "content": [
        "निम्नलिखित परिस्थितियों में धनवापसी जारी की जाती है:",
        "उत्पाद निर्दिष्ट समय के भीतर वापस किया गया हो और अपनी मूल स्थिति में हो।",
        "यदि विनिमय के लिए उपलब्ध उत्पाद स्टॉक में नहीं है, तो पूर्ण धनवापसी दी जाएगी।"
      ] 
    },
    { 
      "title": "अवापसी योग्य और अविनिमय योग्य वस्तुएं", 
      "content": [
        "निम्नलिखित वस्तुएं वापसी और विनिमय के लिए पात्र नहीं हैं:",
        "खोले गए, उपयोग किए गए, या परिवर्तित किए गए उत्पाद।",
        "नाशवान वस्तुएं या कम शेल्फ-लाइफ वाले उत्पाद।",
        "कस्टमाइज़ या व्यक्तिगत रूप से निर्मित वस्तुएं।",
        "गिफ्ट कार्ड, डिजिटल उत्पाद और सेल आइटम।"
      ] 
    },
    { 
      "title": "क्षतिग्रस्त या दोषपूर्ण उत्पाद", 
      "content": [
        "डिलीवरी के 2 दिनों के भीतर हमें ऑर्डर विवरण और उत्पाद की तस्वीरों के साथ सूचित करें।",
        "हम बिना किसी अतिरिक्त लागत के वापसी की व्यवस्था करेंगे और प्रतिस्थापन या धनवापसी प्रदान करेंगे।"
      ] 
    },
    { 
      "title": "ऑर्डर संशोधन", 
      "content": [
        "यदि ऑर्डर अभी तक शिप नहीं किया गया है, तो उसमें परिवर्तन किया जा सकता है।",
        "संशोधनों के लिए तुरंत हमसे संपर्क करें।"
      ] 
    },
    { 
      "title": "हमसे संपर्क करें", 
      "content": [
        "विनिमय, वापसी, या धनवापसी से संबंधित किसी भी प्रश्न के लिए हमसे संपर्क करें:",
        "ईमेल: Support@terraclenz.com",
        "फोन: 7022519222"
      ] 
    }
  ]
  
  const sectionse = [
    { title: "Exchange Policy", content: [
      "We offer exchanges for products under specific conditions:",
      "Eligibility for Exchange:",
      "The product is defective, damaged, or incorrect at the time of delivery.",
      "The product is unused, unwashed, and in its original condition with all tags/labels and packaging intact.",
      "The exchange request is made within the same day of delivery."
    ] },
    { title: "Return Policy", content: [
      "If you're not completely satisfied with your purchase, returns are accepted under these conditions:",
      "The product is unused, unwashed, and in its original condition with all packaging and tags intact.",
      "The return request is made within 2 days of delivery.",
      "Items marked as \"non-returnable\" or \"final sale\" are not eligible for return."
    ] },
    { title: "Refunds", content: [
      "Refunds are issued in the following scenarios:",
      "The product is returned within the stipulated time and is in its original condition.",
      "If the exchange product is out of stock, a full refund will be provided."
    ] },
    { title: "Non-Returnable and Non-Exchangeable Items", content: [
      "The following items are non-returnable and non-exchangeable:",
      "Opened, used, or altered products.",
      "Perishable goods or items with a short shelf-life.",
      "Customized or personalized items.",
      "Gift cards, digital products, and sale items."
    ] },
    { title: "Damaged or Defective Products", content: [
      "Notify us within 2 days of delivery with order details and product images.",
      "We will arrange for a return at no extra cost and provide a replacement or refund."
    ] },
    { title: "Order Modifications", content: [
      "Changes to your order can only be accommodated if the order has not been shipped.",
      "Contact us immediately for modifications."
    ] },
    { title: "Contact Us", content: [
      "For any questions regarding exchanges, returns, or refunds, contact us: ",
      "Email: Support@terraclenz.com ",
      "  Phone: 7022519222"
    ] }
  ];
  const sectionska = [
    { title: "ಬದಲಾವಣೆ ನೀತಿ", content: [
      "ನಿರ್ದಿಷ್ಟ ಶರತ್ತುಗಳ ಅಡಿಯಲ್ಲಿ ನಾವು ಉತ್ಪನ್ನಗಳ ಬದಲಾವಣೆ ನೀಡುತ್ತೇವೆ:",
      "ಬದಲಾವಣೆಗೆ ಅರ್ಹತೆ:",
      "ಉತ್ಪನ್ನವು ವಿತರಣೆಯ ಸಮಯದಲ್ಲಿ ಹಾನಿಗೊಂಡಿದೆ, ಹಾಳಾಗಿದೆ, ಅಥವಾ ತಪ್ಪಾಗಿದೆ.",
      "ಉತ್ಪನ್ನವನ್ನು ಬಳಸದಿರಬೇಕು, ತೊಳೆದಿರಬಾರದು, ಮತ್ತು ಎಲ್ಲಾ ಟ್ಯಾಗ್‌ಗಳು/ಲೇಬಲ್‌ಗಳು ಮತ್ತು ಪ್ಯಾಕೇಜಿಂಗ್ ಸಹಿತ ಮೂಲ ಸ್ಥಿತಿಯಲ್ಲಿರಬೇಕು.",
      "ವಿತರಣೆಯ ಅದೇ ದಿನದೊಳಗೆ ಬದಲಾವಣೆ ಕೋರಿ ವಿನಂತಿ ಮಾಡಬೇಕು."
    ] },
    { title: "ಮರುಪಾವತಿ ನೀತಿ", content: [
      "ನೀವು ನಿಮ್ಮ ಖರೀದಿಯಿಂದ ಸಂಪೂರ್ಣ ತೃಪ್ತರಾಗದಿದ್ದರೆ, ಈ ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ವಾಪಸಾತಿ ಸ್ವೀಕರಿಸಲಾಗುತ್ತದೆ:",
      "ಉತ್ಪನ್ನವನ್ನು ಬಳಸದಿರಬೇಕು, ತೊಳೆದಿರಬಾರದು, ಮತ್ತು ಮೂಲ ಸ್ಥಿತಿಯಲ್ಲಿರುವ ಪ್ಯಾಕೇಜಿಂಗ್ ಮತ್ತು ಟ್ಯಾಗ್‌ಗಳೊಂದಿಗೆ ಇರಬೇಕು.",
      "ವಿತರಣೆಯ 2 ದಿನಗಳೊಳಗೆ ವಾಪಸಾತಿ ವಿನಂತಿ ಮಾಡಬೇಕು.",
      "\"ವಾಪಸಾತಿಗೆ ಅರ್ಹವಿಲ್ಲ\" ಅಥವಾ \"ಅಂತಿಮ ಮಾರಾಟ\" ಎಂದು ಗುರುತಿಸಲಾದ ವಸ್ತುಗಳನ್ನು ವಾಪಸಾತಿ ಮಾಡಲಾಗುವುದಿಲ್ಲ."
    ] },
    { title: "ಪಾವತಿಸು", content: [
      "ಪಾವತಿ ಈ ಸಂದರ್ಭಗಳಲ್ಲಿ ನೀಡಲಾಗುತ್ತದೆ:",
      "ಉತ್ಪನ್ನವು ನಿಗದಿತ ಅವಧಿಯೊಳಗೆ ವಾಪಸಾತಿ ಮಾಡಲಾಗುತ್ತದೆ ಮತ್ತು ಅದರ ಮೂಲ ಸ್ಥಿತಿಯಲ್ಲಿರಬೇಕು.",
      "ಬದಲಾವಣೆಗೆ ಇರುವ ಉತ್ಪನ್ನ ಸ್ಟಾಕ್‌ನಲ್ಲಿ ಲಭ್ಯವಿಲ್ಲದಿದ್ದರೆ, ಪೂರ್ಣ ಹಣ ಮರಳಿಸಲಾಗುತ್ತದೆ."
    ] },
    { title: "ವಾಪಸಾತಿ ಮಾಡಲಾಗದ ಮತ್ತು ಬದಲಾವಣೆ ಮಾಡಲಾಗದ ವಸ್ತುಗಳು", content: [
      "ಕೆಳಗಿನ ವಸ್ತುಗಳನ್ನು ವಾಪಸಾತಿ ಅಥವಾ ಬದಲಾವಣೆ ಮಾಡಲಾಗುವುದಿಲ್ಲ:",
      "ತೆರೆದ, ಬಳಸಿದ, ಅಥವಾ ಪರಿವರ್ತಿತ ಉತ್ಪನ್ನಗಳು.",
      "ಶೀಘ್ರ ಹಾಳಾಗುವ ವಸ್ತುಗಳು ಅಥವಾ ಕಡಿಮೆ ಶೆಲ್ಫ್-ಲೈಫ್ ಇರುವ ವಸ್ತುಗಳು.",
      "ವ್ಯಕ್ತಿಗತ ಅಥವಾ ಕಸ್ಟಮೈಸ್ ಮಾಡಿದ ವಸ್ತುಗಳು.",
      "ಗಿಫ್ಟ್ ಕಾರ್ಡ್‌ಗಳು, ಡಿಜಿಟಲ್ ಉತ್ಪನ್ನಗಳು, ಮತ್ತು ಮಾರಾಟದ ವಸ್ತುಗಳು."
    ] },
    { title: "ಹಾನಿಗೊಂಡ ಅಥವಾ ಹಾಳಾದ ಉತ್ಪನ್ನಗಳು", content: [
      "ಆರ್ಡರ್ ವಿವರಗಳು ಮತ್ತು ಉತ್ಪನ್ನದ ಚಿತ್ರಗಳೊಂದಿಗೆ ವಿತರಣೆಯ 2 ದಿನಗಳೊಳಗೆ ನಮಗೆ ಮಾಹಿತಿ ನೀಡಿ.",
      "ನಾವು ಉಚಿತವಾಗಿ ವಾಪಸಾತಿ ವ್ಯವಸ್ಥೆ ಮಾಡುತ್ತೇವೆ ಮತ್ತು ಬದಲಾವಣೆ ಅಥವಾ ಹಣ ಮರಳಿಸುತ್ತೇವೆ."
    ] },
    { title: "ಆರ್ಡರ್ ತಿದ್ದುಪಡಿ", content: [
      "ಆರ್ಡರ್‌ನ್ನು ರವಾನಿಸಲಾಗಿಲ್ಲದಿದ್ದರೆ ಮಾತ್ರ ಬದಲಾವಣೆಗಳನ್ನು ಮಾಡಬಹುದು.",
      "ತಕ್ಷಣವೇ ಸಂಪರ್ಕಿಸಿ ತಿದ್ದುಪಡಿ ಮಾಡಲು."
    ] },
    { title: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ", content: [
      "ಬದಲಾವಣೆ, ವಾಪಸಾತಿ, ಅಥವಾ ಪಾವತಿ ಕುರಿತಾಗಿ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿದ್ದರೆ, ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ:",
      "ಇಮೇಲ್: Support@terraclenz.com ",
      "ಫೋನ್: 7022519222"
    ] }
  ];
  const sectionste = [
    { title: "మార్పిడి విధానం", content: [
      "కొన్ని నిబంధనల ప్రకారం, మేము ఉత్పత్తుల మార్పిడిని అందిస్తున్నాము:",
      "మార్పిడికి అర్హత:",
      "ఉత్పత్తి డెలివరీ సమయంలో దెబ్బతిన్న, క్షతిగ్రస్తమైనది లేదా తప్పుగా పంపబడినది.",
      "ఉత్పత్తి ఉపయోగించబడకూడదు, కడుగకూడదు, మరియు అన్ని ట్యాగ్‌లు/లేబుల్‌లు మరియు ప్యాకేజింగ్‌తో అసలు స్థితిలో ఉండాలి.",
      "డెలివరీ అయిన అదే రోజున మార్పిడి కోసం అభ్యర్థించాలి."
    ] },
    { title: "రిటర్న్ పాలసీ", content: [
      "మీరు మీ కొనుగోలుతో పూర్తిగా సంతృప్తి చెందకపోతే, ఈ షరతుల ప్రకారం రిటర్న్స్ అంగీకరించబడతాయి:",
      "ఉత్పత్తి ఉపయోగించబడకూడదు, కడుగకూడదు, మరియు అసలు ప్యాకేజింగ్ మరియు ట్యాగ్‌లతో ఉండాలి.",
      "డెలివరీ తర్వాత 2 రోజుల్లో రిటర్న్ అభ్యర్థించాలి.",
      "\"రిటర్న్‌కు అర్హం కాదు\" లేదా \"ఫైనల్ సేల్\" గా మార్క్ చేయబడిన వస్తువులు తిరిగి ఇవ్వలేరు."
    ] },
    { title: "ఫండ్స్", content: [
      "ఈ సందర్భాల్లో ఫండ్‌లు అందించబడతాయి:",
      "ఉత్పత్తి నిర్ణీత సమయంలో తిరిగి ఇచ్చినప్పుడు మరియు అసలు స్థితిలో ఉన్నప్పుడు.",
      "మార్పిడికి ఉత్పత్తి స్టాక్‌లో లేకుంటే, పూర్తి రీఫండ్ అందించబడుతుంది."
    ] },
    { title: "తిరిగి ఇవ్వలేని మరియు మార్చలేని వస్తువులు", content: [
      "ఈ వస్తువులను తిరిగి ఇవ్వలేరు లేదా మార్చలేరు:",
      "ఒకసారి తెరిచిన, ఉపయోగించిన లేదా మార్పు చేసిన ఉత్పత్తులు.",
      "తక్కువ కాలపరిమితి గల నాశనమయ్యే వస్తువులు.",
      "అనుకూలీకరించిన లేదా వ్యక్తిగతీకరించిన వస్తువులు.",
      "గిఫ్ట్ కార్డులు, డిజిటల్ ఉత్పత్తులు, మరియు అమ్మకానికి ఉన్న వస్తువులు."
    ] },
    { title: "డ్యామేజ్ అయిన లేదా లోపభూయిష్ట ఉత్పత్తులు", content: [
      "ఆర్డర్ వివరాలు మరియు ఉత్పత్తి చిత్రాలతో డెలివరీ తర్వాత 2 రోజుల్లో మాకు తెలియజేయండి.",
      "మేము ఉచిత రిటర్న్ ఏర్పాటును చేసి, మార్పిడి లేదా రీఫండ్‌ను అందిస్తాము."
    ] },
    { title: "ఆర్డర్ మార్పులు", content: [
      "మీ ఆర్డర్ ఇంకా షిప్ కాకపోతే మార్పులను చేయగలము.",
      "మార్పుల కోసం తక్షణమే సంప్రదించండి."
    ] },
    { title: "మమ్మల్ని సంప్రదించండి", content: [
      "మార్పిడులు, రిటర్న్స్, లేదా రీఫండ్‌ల గురించి ఏవైనా ప్రశ్నలుంటే, మమ్మల్ని సంప్రదించండి:",
      "ఇమెయిల్: Support@terraclenz.com ",
      "ఫోన్: 7022519222"
    ] }
  ];
  const sectionsta = [
    { title: "பரிமாற்றக் கொள்கை", content: [
      "குறிப்பிட்ட நிபந்தனைகளின் கீழ் தயாரிப்புகளுக்கான பரிமாற்றங்களை நாங்கள் வழங்குகிறோம்: பரிமாற்றத்திற்கான தகுதி: தயாரிப்பு டெலிவரி நேரத்தில் குறைபாடுடையதாகவோ, சேதமடைந்ததாகவோ அல்லது தவறாகவோ உள்ளது. தயாரிப்பு பயன்படுத்தப்படாமல், கழுவப்படாமல், அதன் அசல் நிலையில் அனைத்து டேக்குகள்/லேபிள்கள் மற்றும் பேக்கேஜிங் அப்படியே உள்ளது. டெலிவரி செய்யப்பட்ட அதே நாளுக்குள் பரிமாற்ற கோரிக்கை செய்யப்படுகிறது."
    ] },
    { title: "திரும்பும் கொள்கை", content: [
      "உங்கள் கொள்முதலில் நீங்கள் முழுமையாக திருப்தி அடையவில்லை என்றால், பின்வரும் நிபந்தனைகளின் கீழ் திருப்பி அனுப்பப்படும் பொருட்கள் ஏற்றுக்கொள்ளப்படும்: தயாரிப்பு பயன்படுத்தப்படாமல், கழுவப்படாமல், அதன் அசல் நிலையில் அனைத்து பேக்கேஜிங் மற்றும் குறிச்சொற்களும் அப்படியே இருக்க வேண்டும். டெலிவரி செய்யப்பட்ட 2 நாட்களுக்குள் திருப்பி அனுப்ப கோரிக்கை விடுக்கப்படும். திருப்பி அனுப்ப முடியாதது அல்லது இறுதி விற்பனை எனக் குறிக்கப்பட்ட பொருட்கள் திருப்பி அனுப்ப தகுதியற்றவை."
    ] },
    { title: "பணத்தைத் திரும்பப் பெறுதல்", content: [
      "பின்வரும் சூழ்நிலைகளில் பணத்தைத் திரும்பப் பெறலாம்: தயாரிப்பு குறிப்பிட்ட நேரத்திற்குள் திருப்பித் தரப்படும் மற்றும் அதன் அசல் நிலையில் இருக்கும். பரிமாற்ற தயாரிப்பு கையிருப்பில் இல்லை என்றால், முழு பணத்தைத் திரும்பப் பெறுவீர்கள்."
    ] },
    { title: "திருப்பி அனுப்ப முடியாத மற்றும் மாற்ற முடியாத பொருட்கள்", content: [
      "பின்வரும் பொருட்கள் திரும்பப் பெற முடியாதவை மற்றும் மாற்ற முடியாதவை: திறந்த, பயன்படுத்தப்பட்ட அல்லது மாற்றப்பட்ட பொருட்கள். குறுகிய கால அடுக்கு வாழ்க்கை கொண்ட அழிந்துபோகக்கூடிய பொருட்கள் அல்லது பொருட்கள். தனிப்பயனாக்கப்பட்ட அல்லது தனிப்பயனாக்கப்பட்ட பொருட்கள். பரிசு அட்டைகள், டிஜிட்டல் பொருட்கள் மற்றும் விற்பனை பொருட்கள்."
    ] },
    { title: "சேதமடைந்த அல்லது குறைபாடுள்ள தயாரிப்புகள்", content: [
      "ஆர்டர் விவரங்கள் மற்றும் தயாரிப்பு படங்களுடன் டெலிவரி செய்யப்பட்ட 2 நாட்களுக்குள் எங்களுக்குத் தெரிவிக்கவும். கூடுதல் செலவு இல்லாமல் திருப்பி அனுப்ப நாங்கள் ஏற்பாடு செய்வோம், மேலும் மாற்று அல்லது பணத்தைத் திரும்பப் பெறுவோம்."
    ] },
    { title: "ஆர்டர் மாற்றங்கள்", content: [
      "உங்கள் ஆர்டரில் மாற்றங்கள் செய்யப்பட்டால், ஆர்டர் அனுப்பப்படவில்லை என்றால் மட்டுமே ஏற்றுக்கொள்ளப்படும். மாற்றங்களுக்கு உடனடியாக எங்களைத் தொடர்பு கொள்ளவும்."
    ] },
    { title: "எங்களை தொடர்பு கொள்ள", content: [
      "பரிமாற்றங்கள், திருப்பி அனுப்புதல் அல்லது பணத்தைத் திரும்பப் பெறுதல் தொடர்பான ஏதேனும் கேள்விகளுக்கு, எங்களைத் தொடர்பு : ",
      "மின்னஞ்சல்: Support@terraclenz.com ",
      "தொலைபேசி: 7022519222"
    ] }
  ];
  const [fb,setFB] =useState(fben)
      const [sections, setHomeen] = useState(sectionse)
  
      useEffect(() => {
          const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
      switch (storedLanguage) {
          case "kn":
              setHomeen(sectionska);
              setFB(fbka);
              break;
          case "te":
              setHomeen(sectionste);
              setFB(fbte);
              break;
          case "ta":
              setHomeen(sectionsta);
              setFB(fbta);
              break;
              case "hi":
                setHomeen(sectionshi);
                setFB(fbhi);
                break;
          default:
                  setHomeen(sectionse);
                  setFB(fben);
      }
  
  }, []);
  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2 ">
        <div className="container">
        <div className="breadcrumb-title">
            <h2>{fb["1"]}</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">{fb["2"]}</Link></li>
              <li>{fb["1"]}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="faqs-container">
        {sections.map((section, index) => (
      <div className="faq" key={index}>
      <h6 onClick={() => toggleFAQ(index)} className="faq-question">
        {section.title} {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
      </h6>
      <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
        {openIndex === index && section.content}
      </div>
    </div>
        ))}
      </div>
    </>
  );
};

export default ExchangeAndReturnPolicy;
